export default __webpack_public_path__ + "static/media/apple-touch-icon.c4c990b9.png";